var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Catalogue } from './Catalogue';
import { Type } from './Type';
import { Parametre } from './Parametre';
import { Habilitation } from '../habilitation/Habilitation';
import { Utilisateur } from '../utilisateur/Utilisateur';
import { Error } from '../error/Error';
import { Tab, Tabs } from '@mui/material';
import { useState } from 'react';
import { getOriginalUser } from '../../services/utilisateur';
import { CardTitle } from '../../utils/CardTitle';
import { AdministrationIcon } from '../../utils/Icons';
import { Sectorisation } from '../sectorisation/Sectorisation';
import { Reaffectation } from '../reaffectation/Reaffectation';
var originalUser = getOriginalUser();
export var Administration = function () {
    var _a = useState(0), navigationSelected = _a[0], setNavigationSelected = _a[1];
    if (!originalUser.IsAdministrateur) {
        return _jsx(Error, { status: 401 });
    }
    var TABS = [
        { label: 'Catalogue', component: _jsx(Catalogue, {}), show: true },
        { label: 'Typage', component: _jsx(Type, {}), show: true },
        { label: 'Paramétrage', component: _jsx(Parametre, {}), show: true },
        {
            label: 'Habilitation',
            component: _jsx(Habilitation, {}),
            show: originalUser.Licence.UseVision,
        },
        {
            label: 'Sectorisation',
            component: _jsx(Sectorisation, {}),
            show: originalUser.Licence.UseVision,
        },
        {
            label: 'Réaffectation',
            component: _jsx(Reaffectation, {}),
            show: originalUser.Licence.UseVision,
        },
        { label: 'Utilisateur', component: _jsx(Utilisateur, {}), show: true },
    ].filter(function (tab) { return tab.show; });
    return (_jsxs(_Fragment, { children: [_jsx(CardTitle, { title: "Administration", startIcon: _jsx(AdministrationIcon, {}), color: "neutre", withFileAriane: true }), _jsx(Tabs, __assign({ variant: "scrollable", allowScrollButtonsMobile: true, className: "mb-small", value: navigationSelected, onChange: function (e, newValue) { return setNavigationSelected(newValue); } }, { children: TABS.map(function (tab) { return (_jsx(Tab, { label: tab.label }, tab.label)); }) })), TABS[navigationSelected].component] }));
};
//# sourceMappingURL=Administration.js.map